import type { FormConfig } from '@tencent/wb-ext-form';
import { FormItemName, FormItemType } from '@framework/workbench/drawer/constants';
import i18n from '@i18next/i18n';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';
import getCurrentFormatTime from '@src/slide/domain/ui-model/element-modeles/property/text/utils/format-datetime';
import { DatetimeType } from '@src/slide/domain/ui-model/element-modeles/property/slide-footer/slide-footer.interface';

export const SpinOptions = {
    step: 1,
    max: 9999,
    min: 0,
};

const SpinStyle = {
    fontSize: '12px',
};

function getFieldTypeOptions() {
    const datetime = (AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices).
        getInfrastructureService().initDatetime;
    const { language } = i18n;
    let lan;
    if (language === 'zh-CN' || language === 'zh-HK' || language === 'zh') {
        lan = 'ea';
    } else {
        lan = 'latin';
    }
    const options: any = [];
    for (let i = 1;i <= 13;i++) {
        const text = getCurrentFormatTime(i, lan, datetime);
        options.push({ key: `datetime${i}`, content: text });
    }
    options.push({ key: 'datetimeyyyy', content: getCurrentFormatTime('yyyy', lan, datetime) });
    return options;
}

const datetimeTypeOptions = [
    { key: DatetimeType.AUTO_UPDATE, content: i18n.t('自动更新') },
    { key: DatetimeType.FIXED, content: i18n.t('固定') },
];

export const FORM_CONFIGS: FormConfig[] = [
    {
        name: FormItemName.SLIDE_NUMBER,
        type: FormItemType.CUSTOM,
    },
    {
        type: FormItemType.SPIN,
        name: FormItemName.SLIDE_NUMBER_START,
        options: SpinOptions,
        style: SpinStyle,
        defaultValue: 1,
    },
    {
        type: FormItemType.TEXT,
        name: FormItemName.SLIDE_NUMBER_START_TEXT,
        value: i18n.t('开始于'),
        style: SpinStyle,
        options: {
            align: 'center',
        },
    },
    {
        name: FormItemName.SLIDE_FOOTER,
        type: FormItemType.CUSTOM,
    },
    {
        name: FormItemName.SLIDE_FOOTER_INPUT,
        type: FormItemType.CUSTOM,
    },
    {
        name: FormItemName.DATETIME,
        type: FormItemType.CUSTOM,
    },
    {
        name: FormItemName.DATETIME_TYPE_SELECT,
        type: FormItemType.SELECT,
        options: {
            selectOptions: datetimeTypeOptions,
        },
    },
    {
        name: FormItemName.DATETIME_INPUT,
        type: FormItemType.CUSTOM,
    },
    {
        name: FormItemName.DATETIME_FIELD_TYPE_SELECT,
        type: FormItemType.SELECT,
        options: {
            selectOptions: getFieldTypeOptions(),
        },
    },
    {
        name: FormItemName.FOOTER_APPLY,
        type: FormItemType.BUTTON,
        options: {
            text: i18n.t('应用到全部'),
        },
    },
];

